import { ArdoqId, Entity } from '@ardoq/api-types';

export const removeEntityById = <T extends Entity>(
  state: T[],
  id: ArdoqId
): T[] => state.filter(({ _id }) => _id !== id);

export const removeEntity = <T extends Entity>(state: T[], entity: T): T[] =>
  removeEntityById(state, entity._id);

export const updateEntity = <T extends Entity>(state: T[], entity: T): T[] =>
  state.map(existing => (existing._id === entity._id ? entity : existing));
